import React from 'react'
import { Link } from 'react-router-dom'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import { Button, Form, Message } from 'semantic-ui-react'
import { updateEmail, getAttributes, isAuthenticated } from '../../services/self'
import logo from '../../Nlogo.png'

 export default class Recover extends React.Component {

   state = {
     isSubmitting: false,
     signedIn: false,
     errorMessage: '',
     isOpen: false,
     submitted: false
   }

   updateEmail(event, serializedForm){
     event.preventDefault()

  //   var username = serializedForm.username;
     var newEmail = serializedForm.email;

     this.setState({submitted: true});
     updateEmail(newEmail)


   }

   getAttributes(event, serializedForm){
     event.preventDefault()

     getAttributes()
   }


   render() {
     return (
    <div className="none">

            <div className="App">
            <div className="Logo">
              <a className="Img-Link" href="#"><Link className="home-link" to='/'><img src={logo} className="App-logo" alt="logo" /></Link></a>
              <a className="Developer-link" href="#"><Link className="home-link" to='/'>Developer</Link></a>
            </div>

            <div className="Navbar-Div">
              <nav className="App-navbar">


                <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
                <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
                <Link className="Centered-link" to='/documentation'>Docs</Link>
                <Link className="Centered-link" to='/tools'>Tools</Link>
                <Link className="Centered-link" to='/community'>Community</Link>

                {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
                {isAuthenticated() ? (<Link className="right" to='' onClick={() => this.logout()}>Log out</Link>) : ''}
                {isAuthenticated() ? '' : (
                <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
                </span>
                )}


              </nav>
            </div>

            <div className="App-banner">

              Newforma World 2018 | October 2 - 5, 2018 | Connecting People, Projects and Information!

            </div>

    <div className="main-content">

      <Form onSubmit={this.updateEmail} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
        <Form.Input label='New Email' name='email' />
        <Message error content={this.state.errorMessage} />
          <Message content={ this.state.submitted ? 'Your email has been updated, please confirm new email with code that was sent to your new email.' : '' }/>
          <Button type='button' onClick={this.close}>Close</Button>
          <Button primary type='submit'>Submit</Button>
      </Form>


      <Form onSubmit={this.getAttributes} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
        <Message error content={this.state.errorMessage} />
        <Button primary type='submit'>Get Attributes</Button>
      </Form>

  </div>
</div>
</div>
)}
}



/** WEBPACK FOOTER **
 ** ./src/pages/UpdateEmail/index.js
 **/